import {List, fromJS} from 'immutable'
import { get, getBlob } from '../../util/http'

/**
 * Actions
 */
const ATTEMPT_GET_PROBLEMS = 'expii/user/ATTEMPT_GET_PROBLEMS'
const ATTEMPT_GET_CONTRIBUTIONS = 'expii/user/ATTEMPT_GET_CONTRIBUTIONS'
const ATTEMPT_GET_USER_INFO = 'expii/user/ATTEMPT_GET_USER_INFO'
const PROCESS_PROFILE_DATA = 'expii/user/PROCESS_PROFILE_DATA'
const RESET_PROFILE_DATA = 'expii/user/RESET_PROFILE_DATA'

/**
 * Reducer
 */
const defaultProfileState = fromJS({
  userInfo: {
    displayName: null,
    pictureUrl: null,
    numSolved: 0,
    numRevisions: 0,
    id: 0,
    isFetching: true
  },
  problems: {
    page: 0,
    totalNum: 0,
    entries: [],
    isFetching: true,
    errorMessage: ''
  },
  contributions: {
    page: 0,
    entries: [],
    isFetching: true
  }
})
function merger(a, b) {
  if (List.isList(a) && List.isList(b)) {
    return a.concat(b)
  }
  if (a && a.mergeWith) {
    return a.mergeWith(merger, b)
  }
  return b
}
export default function reducer(state = defaultProfileState, action = {}) {
  switch (action.type) {
  case ATTEMPT_GET_USER_INFO:
  case ATTEMPT_GET_CONTRIBUTIONS:
  case ATTEMPT_GET_PROBLEMS:
    return state.withMutations(map =>
      map.mergeWith(merger, fromJS(action.payload.type))
    )
  case PROCESS_PROFILE_DATA:
    return state.withMutations(map =>
      map.mergeWith(merger, fromJS(action.payload.type))
    )
  case RESET_PROFILE_DATA:
    return defaultProfileState
  default:
    return state
  }
}

/**
 * Action Creators
 */
export function attemptGetProblems(payload) {
  return { type: ATTEMPT_GET_PROBLEMS, payload }
}

export function attemptGetContributions(payload) {
  return { type: ATTEMPT_GET_CONTRIBUTIONS, payload }
}

export function attemptGetUserInfo(payload) {
  return { type: ATTEMPT_GET_USER_INFO, payload }
}

export function processProfileData(profile_data) {
  return { type: PROCESS_PROFILE_DATA, payload: profile_data }
}

export function resetProfileData() {
  return { type: RESET_PROFILE_DATA }
}

/**
 * Side Effects
 */

export function getUserInfo(userId) {
  return (dispatch, getState) => {
    const isFetchingData = {
      type: {
        userInfo: {
          isFetching: true
        }
      }
    }
    dispatch(attemptGetUserInfo(isFetchingData))
    return get(`/api/v2/user/${userId}/user_info`).then(json => {
      let { success, output } = json
      output['isFetching'] = false
      json = {
        success: success,
        type: {
          userInfo: output
        }
      }
      //setTimeout(() => dispatch(processProfileData(json)), 5000);
      dispatch(processProfileData(json))
    })
  }
}

export function getProfileProblems(userId) {
  return (dispatch, getState) => {
    const isFetchingData = {
      type: {
        problems: {
          isFetching: true
        }
      }
    }
    dispatch(attemptGetProblems(isFetchingData))
    const page = getState().getIn(['profile', 'problems', 'page'])
    return get(`/api/v2/user/${userId}/problems_practice/${page}/`).then(
      json => {
        let { success, output } = json
        const promises = output.problems.map(p=>{
          return new Promise((resolve, reject)=>{
            getBlob(p.renderedContentUrl).then(json => {
              p.renderedQuestion = json[json.length-1]['content']['question'][0]
              resolve(p)
            }).catch(reject)
          })
        })
        Promise.all(promises).then(values => {
          json = {
            success: success,
            type: {
              problems: {
                entries: output.problems,
                totalNum: output.totalNum,
                page: page + 1,
                isFetching: false
              }
            }
          }
          dispatch(processProfileData(json))
        })
      }
    ).catch(response => {
      const json = {
        type: {
          problems: {
            entries: [],
            totalNum: 0,
            page: 0,
            isFetching: false,
            errorMessage: response.error_message
          }
        }
      }
      dispatch(processProfileData(json))
    })
  }
}

export function getProfileContributions(userId) {
  return (dispatch, getState) => {
    const isFetchingData = {
      type: {
        contributions: {
          isFetching: true
        }
      }
    }
    dispatch(attemptGetContributions(isFetchingData))
    const page = getState().getIn(['profile', 'contributions', 'page'])
    return get(`/api/v2/user/${userId}/contributions/${page}/`).then(json => {
      let { success, output } = json
      json = {
        success: success,
        type: {
          contributions: {
            entries: output.contributions,
            totalNum: output.totalNum,
            page: page + 1,
            isFetching: false
          }
        }
      }
      dispatch(processProfileData(json))
    })
  }
}

/**
 * Selectors
 */



// WEBPACK FOOTER //
// ./src/redux/modules/profile.js